import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    target: String
  }

  trigger() {
    if (this.hasTargetValue && this.targetValue) {
      this.printInNewWindow(this.targetValue)
    } else {
      window.print()
    }
  }

  printInNewWindow(selector) {
    const target = document.querySelector(selector)
    if (!target) {
      console.warn(`Print target not found: ${selector}`)
      window.print()
      return
    }

    // Collect all stylesheets from current page
    const stylesheets = Array.from(document.querySelectorAll('link[rel="stylesheet"]'))
      .map(link => link.outerHTML)
      .join('\n')

    const printWindow = window.open('', '_blank')
    if (!printWindow) {
      console.warn('Popup blocked, falling back to regular print')
      window.print()
      return
    }

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Daycare Tour Checklist</title>
        ${stylesheets}
        <style>
          @media print {
            @page { margin: 0.5in; }
          }
        </style>
      </head>
      <body class="bg-white">
        <div class="p-8">
          ${target.innerHTML}
        </div>
        <script>
          window.onload = function() {
            setTimeout(function() {
              window.print();
              window.onafterprint = function() { window.close(); };
            }, 100);
          };
        </script>
      </body>
      </html>
    `)
    printWindow.document.close()
  }
}
